
import Enumerable from "linq";
import * as Moment from "moment";
import { Component, Mixins } from "vue-property-decorator";
import { CurrentEditors, EditConfirmationActionKinds } from "../../../../domain/document";
import { DialogMixin } from "../../../system/mixins";
import { IMessages } from "../../../system";
import { IEditConfirmableAsynchronously } from "../";

@Component
export default class EditConfirmDialogMixin extends Mixins(DialogMixin) implements IEditConfirmableAsynchronously {
  data(): any {
    return {
      action: EditConfirmationActionKinds.Edit,
      messages: [] as (string | IMessages)[],
      isEditable: true,
      isUnlocked: false,
      result: false,
    };
  }
  action: EditConfirmationActionKinds;
  messages: (string | IMessages)[];
  isEditable: boolean;
  isUnlocked: boolean;
  result: boolean;

  get title(): string {
    return "確認";
  }

  get actionName(): string {
    return this.action === EditConfirmationActionKinds.Create
      ? "作成"
      : "編集";
  }

  get header(): string {
    return "該当文書を" + this.actionName + "中のユーザがいます。";
  }

  get forciblyStartCheckboxName(): string {
    return "強制的に" + this.actionName + "開始する";
  }

  get startButtonName(): string {
    return this.actionName + "する";
  }

  toMessages(currentEditors: CurrentEditors[]): (string | IMessages)[] {
    const footers: (string | IMessages)[] = [
      this.actionName + "中の文書を閉じてもらってから" + this.actionName + "してください。",
    ];
    return this.toCurrentEditorsMessage(currentEditors).concat(footers);
  }

  private toCurrentEditorsMessage(editors: CurrentEditors[]): (string | IMessages)[] {
    return Enumerable.from(editors)
      .select(e => this.toCurrentEditorMessage(e))
      .toArray();
  }

  private toCurrentEditorMessage(editor: CurrentEditors): IMessages {
    return {
      messages: [
        "更新者　　　：" + editor.userName,
        "更新端末　　：" + editor.terminalName,
        "更新開始日時：" + Moment(editor.editStartDateTime).format("YYYY/MM/DD HH:mm"),
      ],
    };
  }

  get alertTexts(): string[] {
    return [
      "このまま複数人で" + this.actionName + "継続した場合、以下のような問題が起こる可能性があります。",
      "・先に登録した人の記載内容が、後から登録した人の記載内容で上書きされてしまう。",
      "・先に登録された文書で進捗が進んで、後から登録しようとしても上書きできない。",
    ];
  }

  get alertTextsConfiguration(): string[] {
    return this.replaceAlertTexts(this.$configuration.behavior.document.editor.conflict.alert.message);
  }

  get alertStyle(): any {
    const configuration = this.$configuration.behavior.document.editor.conflict.alert;
    return {
      color: configuration.color,
      fontWeight: configuration.isBold ? "bold" : "normal",
    };
  }

  replaceAlertTexts(source: string): string[] {
    return Enumerable.from(source)
      .aggregate(source, k => k.replace("$action$", this.actionName))
      .split("\n");
  }

  isMessage(source: string | IMessages): boolean {
    return (!source || (typeof source === "string"));
  }

  toMessageClass(source: string | IMessages): string {
    return this.isMessage(source)
      ? "edit-confirm-dialog-message"
      : "edit-confirm-dialog-messages";
  }

  async show(currentEditors: CurrentEditors[], action: EditConfirmationActionKinds, isEditable: boolean): Promise<boolean> {
    // this.$confirmで使うときはフィールド変数ではないところで値を管理しないと値がごちゃまぜになる？
    return this.showModal(async () => {
      this.action = action;
      this.isUnlocked = false;
      this.messages = this.toMessages(currentEditors);
      this.isEditable = isEditable;
      this.result = false;
      await this.waitHidden();
      return this.result;
    });
  }

  confirmAndClose(): void {
    this.result = true;
    this.isVisible = false;
  }

  cancelAndClose(): void {
    this.result = false;
    this.isVisible = false;
  }
}
